const services = [
  {
    name: 'Frontend',
    icon: 'bx bx-devices',
    alt: 'Designs and builds the user-facing layout, style, and interactivity of websites.'
  },
  {
    name: 'Backend',
    icon: 'bx bx-server',
    alt: 'Handles server-side logic, database management, and APIs for web applications.'
  },
  {
    name: 'Accounts Management',
    icon: 'fas fa-file-invoice-dollar',
    alt: 'Maintains financial records, invoicing, payroll, and tax-related data for organizations.'
  },
  {
    name: 'Digital Card',
    icon: 'fas fa-id-badge',
    alt: 'A digital card securely stores personal or business information for easy sharing and online networking.'
  },
  {
    name: 'Content writing / Copywriting',
    icon: 'fas fa-pen-nib',
    alt: 'Crafts engaging text for blogs, ads, websites, and social media marketing.'
  },
  {
    name: 'Social media Management',
    icon: 'bx bx-share-alt',
    alt: 'Plans, creates, and schedules content across social media platforms to grow presence.'
  },
  {
    name: 'Transcription / Captioning',
    icon: 'fas fa-keyboard',
    alt: 'Converts audio or video content into written text for accessibility or clarity.'
  },
  {
    name: 'Virtual Assistance',
    icon: 'fas fa-headset',
    alt: 'Provides remote support like scheduling, emails, and administrative tasks online.'
  },
  {
    name: 'Language Tutoring or Translation',
    icon: 'fas fa-language',
    alt: 'Teaches languages or translates text/audio across different languages with fluency.'
  },
  {
    name: 'Graphic Design (Using Free Tools)',
    icon: 'bx bx-paint',
    alt: 'Creates visual content using tools like Canva for brands and marketing projects.'
  },
  {
    name: 'Blogging / Affiliate Marketing',
    icon: 'fas fa-blog',
    alt: 'Writes posts and promotes products to earn commission through affiliate links.'
  },
  {
    name: 'Data Entry / Typing Jobs',
    icon: 'fas fa-keyboard',
    alt: 'Inputs data accurately into digital systems for administrative or research purposes.'
  },
  {
    name: 'Open Source Contribution',
    icon: 'fas fa-code-branch',
    alt: 'Collaborates on free software projects to gain experience and build portfolios.'
  },
  {
    name: 'YouTube or Podcast Creation',
    icon: 'fas fa-podcast',
    alt: 'Creates and shares video or audio content to educate, entertain, or inspire audiences.'
  },
  {
    name: 'Voice Acting / Voiceover Work',
    icon: 'fas fa-microphone',
    alt: 'Lends voice to narrations, animations, ads, or audiobooks professionally.'
  },
  {
    name: 'Proofreading & Editing',
    icon: 'fas fa-spell-check',
    alt: 'Reviews text to correct grammar, punctuation, and ensure clarity and consistency.'
  },
  {
    name: 'Online Surveys & Microtasks',
    icon: 'fas fa-tasks',
    alt: 'Completes small online tasks or surveys to earn income passively.'
  },
  {
    name: 'Search Engine Evaluation',
    icon: 'fas fa-search',
    alt: 'Assesses search engine results for relevance, accuracy, and user experience.'
  },
  {
    name: 'Online Course Creation',
    icon: 'fas fa-chalkboard-teacher',
    alt: 'Builds and publishes educational content online to teach skills and earn.'
  },
  {
    name: 'Online Counseling',
    icon: 'fas fa-user-md',
    alt: 'Offers emotional guidance or career advice through virtual sessions and platforms.'
  },
  {
    name: 'Resume Writing & LinkedIn Optimization',
    icon: 'fas fa-id-card',
    alt: 'Crafts professional resumes and profiles to boost job search success.'
  },
  {
    name: 'Ebook Writing',
    icon: 'fas fa-book',
    alt: 'Authors digital books to inform, entertain, or market products and services.'
  }
];
export default services;